import Swal from "sweetalert2";
import getErrorMessage from "./get-error-message";

const showErrorMessage = (error: unknown, title = "Erro") => {
  const errorMessage = getErrorMessage(error);
  Swal.fire({ icon: "error", title: title, text: errorMessage });
};

export default showErrorMessage;
